import { finalRouteApi } from "./CommonApiUrl"


const showOrderDefaultURL = {
    finalRouteApilistApi: `${finalRouteApi}`,
    listApi: `${finalRouteApi}/TVShows-HomePage-Order/index`,
    orderApi: `${finalRouteApi}/TvShows-HomePage-Order/ordering`,
    editApi: `${finalRouteApi}/TvShows-HomePage-Order/edit`,
    updateApi: `${finalRouteApi}/TvShows-HomePage-Order/update`,

    editRouteLink: `${finalRouteApi}/Audio_URL`,

    enableSettingURL: `${finalRouteApi}/Web-TVShows-HomePage/index`,
    updateSettingURL: `${finalRouteApi}/Web-TVShows-HomePage/update`,

    enableSettingMobileURL: `${finalRouteApi}/Mobile-TVShows-HomePage/index`,
    updateSettingMobileURL: `${finalRouteApi}/Mobile-TVShows-HomePage/update`,

    enableSettingTvURL: `${finalRouteApi}/TVShows-TVHomePage/index`,
    updateSettingTvURL: `${finalRouteApi}/TVShows-TVHomePage/update`,

    enableSettingSamsungURL: `${finalRouteApi}/Samsung-TVShows-HomePage/index`,
    updateSettingSamsungURL: `${finalRouteApi}/Samsung-TVShows-HomePage/update`,
    singleSeriesSamsungURL: `${finalRouteApi}/Samsung-TVShows-Single_Series_Update`,

    enableSettingLgURL: `${finalRouteApi}/LG-TVShows-HomePage/index`,
    updateSettingLgURL: `${finalRouteApi}/LG-TVShows-HomePage/update`,
    singleSeriesLgURL: `${finalRouteApi}/LG-TVShows-Single_Series_Update`,

    singleSeriesURL: `${finalRouteApi}/Web-TvShowsHomePage/Single_Series_Update`,
    singleSeriesMobileURL: `${finalRouteApi}/Mobile-TvShowsHomePage/Single_Series_Update`,
    singleSeriesTvURL: `${finalRouteApi}/TVShows-TVHomePage/Single_Series_Update`,
}

export { showOrderDefaultURL }